import { axios } from 'features/common/utils/axios.utils';
import { getData } from 'features/common/utils/api.utils';

import { IAppLinksGetResponse } from './AppLinks.types';

/** Get list of links for the app */
export function appLinksGet() {
    return axios.get<IAppLinksGetResponse>(`/api/v1/menu-links/`).then(getData);
}
